<template>
  <div class="tooltip">
    <font-awesome-icon
      :icon="['fa', 'info-circle']"
    />
    <span class="tooltiptext tooltip-top">{{ toolTipText }}</span>
  </div>
</template>
<script>
export default {
  props: {
    toolTipText: {
      type: String,
      required: true
    },
  }
}
</script>
